const generalFreightOrder = {
	"container.transport.generalFreightOrder.orderHeader": "ORDER",
	"container.transport.generalFreightOrder.shipper": "Pickup",
	"container.transport.generalFreightOrder.consignee": "Delivery",
	"container.transport.generalFreightOrder.pickupReference": "Pickup Reference",
	"container.transport.generalFreightOrder.deliveryReference": "Delivery Reference",
	"container.transport.generalFreightOrder.requestedPickup": "Requested Pickup",
	"container.transport.generalFreightOrder.requestedDelivery": "Requested Delivery",
	"container.transport.generalFreightOrder.pickupOrDeliveryTimeslot": "DC Timeslot",
	"container.transport.generalFreightOrder.pickupTimeslot": "DC Timeslot",
	"container.transport.generalFreightOrder.deliveryTimeslot": "DC Timeslot",
	"container.transport.generalFreightOrder.defaultCarrierName": "MOVe Freight",
	"container.transport.generalFreightOrder.hirePallets": "Total Pallets",
	"container.transport.generalFreightOrder.nonHirePallets": "Non-Hire Pallets",
	"container.transport.generalFreightOrder.palletReference": "Pallet Type",
	"container.transport.generalFreightOrder.palletReferencePlaceholder": "Enter Chep, Loscam etc",
	"container.transport.generalFreightOrder.productCode": "Product Code",
	"container.transport.generalFreightOrder.description": "Description",
	"container.transport.generalFreightOrder.cargoType": "Cargo Type",
	"container.transport.generalFreightOrder.commodity": "Commodity",
	"container.transport.generalFreightOrder.packageType": "Package Type",
	"container.transport.generalFreightOrder.quantity": "Quantity",
	"container.transport.generalFreightOrder.weight": "Weight (kg)",
	"container.transport.generalFreightOrder.weight.without.symbol": "Weight",
	"container.transport.generalFreightOrder.volume": "Volume (m³)",
	"container.transport.generalFreightOrder.volume.without.symbol": "Volume",
	"container.transport.generalFreightOrder.dgCode": "UN No",
	"container.transport.generalFreightOrder.dgClass": "DG Class",
	"container.transport.generalFreightOrder.totalQuantity": "Total Quantity",
	"container.transport.generalFreightOrder.totalWeight": "Total Weight",
	"container.transport.generalFreightOrder.totalVolume": "Total Volume",
	"container.transport.generalFreightOrder.total": "Total",
	"container.transport.generalFreightOrder.save": "Save",
	"container.transport.generalFreightOrder.cancel": "Cancel",
	"container.transport.generalFreightOrder.edit": "Edit",
	"container.transport.generalFreightOrder.sendReceiverEmailNotification": "Send receiver email notification"
};

export { generalFreightOrder };
